<template>
    <div>
        <zm-button v-clipboard:copy="token" v-clipboard:success="copySuccess" id="copy-btn" v-show="false"></zm-button>
        <zm-row v-if="!selectedCmkAppId">
            <zm-select v-model="namespace" class="select-inline"
            placeholder="namespace" filterable @change="setNamespace"
            popper-class="select-popper">
                <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
            </zm-select>
            <zm-input @keyup.enter.native="fetchData" style="width: 300px;margin-right: 10px;" v-model="applicationName">
                <zm-button slot="append" icon="zm-icon-search" @click="fetchData"></zm-button>
            </zm-input>
            <zm-button plain @click="showRegister()" type="primary" v-if="permission.isSuperAdmin">Register</zm-button>
        </zm-row>
        <zm-row v-if="selectedCmkAppId">
            <zm-button type="link" @click="selectedCmkAppId = ''"><i class="zm-icon-left"></i>{{ selectedCmkAppName }}</zm-button>
        </zm-row>
        <div class="table-container" v-if="!selectedCmkAppId">
            <zm-table v-loading="loading"
            :data="list.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)">
                <zm-table-column prop="applicationName" label="Application Name">
                </zm-table-column>
                <!-- <zm-table-column prop="lastBackup" label="Last Backup">
                </zm-table-column> -->
                <zm-table-column width="230px">
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" title="edit application" @click="showEdit(scope.row.id)" v-if="buttonPermission(scope.row.id)"></zm-button>
                        <zm-button size="small" type="icon" class="iconfont icon-token" title="generate jwt token" v-if="buttonPermission(scope.row.id)"
                        @click="showGenerateToken(scope.row.id)" style="margin-right: 0;font-size: 14px;"></zm-button>
                        <!-- <zm-button size="small" type="icon" icon="zm-icon-copy" title="generate backup" @click="generateBackup(scope.row.id)"></zm-button> -->
                        <zm-button size="small" type="icon" icon="zm-icon-delete" title="delete application" @click="deleteApp(scope.row.id)" v-if="buttonPermission(scope.row.id)"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-refresh" title="init cmk"
                            @click="initCmk(scope.row.id)" v-if="buttonPermission(scope.row.id) && !scope.row.cmkInit"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-list-view" title="list cmk"
                            @click="listCmk(scope.row)" v-if="buttonPermission(scope.row.id) && scope.row.cmkInit && scope.row.enableCMKManagement"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageable.pageSize"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="list.length">
                </zm-pagination>
            </div>
        </div>
        <cmk :applicationId="selectedCmkAppId" v-if="selectedCmkAppId"></cmk>
        <zm-dialog :title="isCreate ? 'Register Application' : 'Edit Application'" :visible.sync="registerVisible">
            <zm-form :model="register" label-position="left" ref="registerForm" :rules="registerRules" label-width="180px">
                <zm-form-item label="Namespace" prop="namespace">
                    {{ register.namespace }}
                </zm-form-item>
                <zm-form-item label="Application Name" prop="name">
                    <zm-input size="small" v-model="register.name" :readonly="!isCreate"></zm-input>
                </zm-form-item>
                <zm-form-item label="Description" prop="description">
                    <zm-input type="textarea" size="small" v-model="register.description"></zm-input>
                </zm-form-item>
                <!-- <zm-form-item label="Owner" prop="owner">
                    <zm-input size="small" v-model="register.owner"></zm-input>
                </zm-form-item> -->
                <zm-form-item label="CmkInit" prop="cmkInit">
                    <zm-switch size="small" v-model="register.cmkInit" :disabled="!isCreate"></zm-switch>
                </zm-form-item>
            </zm-form>
            <div class="zm-form-item zm-form--label-left">
                <label class="zm-form-item__label" style="width: 180px;">Owner</label>
                <div style="margin-left: 180px;">
                    <zm-tag size="medium"
                        class="input-tag"
                        :key="tag"
                        v-for="tag in ownerList"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                        {{ tag }}
                    </zm-tag>
                    <zm-input
                        class="input-new-tag"
                        v-if="inputTagVisible"
                        v-model="inputTagValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm()"
                        @blur="handleInputConfirm()"
                        >
                    </zm-input>
                    <zm-button size="small" v-else class="button-new-tag" @click="showInput()">+</zm-button>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="registerVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="createApplication()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Generate JWT Token" :visible.sync="generateVisible">
            <zm-form :model="generateForm" label-position="left" ref="generateForm">
                <zm-form-item label="Expired Time">
                    <zm-date-picker
                        :picker-options="pickerOptions"
                        v-model="generateForm.expiredTime"
                        type="datetime"
                        value-format="timestamp"
                        placeholder="">
                    </zm-date-picker>
                </zm-form-item>
                <zm-form-item lable="JWT Token" v-if="token" style="word-break: break-all;">
                    <zm-input id="textCopy" type="textarea" v-model="token" readonly autosize v-show="false"></zm-input>
                    {{ token }}
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="generateVisible = false">Close</zm-button>
                <button type="button" id="copybutton" class="zm-button zm-button--primary"
                    v-show="token"
                    ref="copy"
                    @click="handleCopy"
                    data-clipboard-action="copy"
                    data-clipboard-target="#textCopy">Copy</button>
                <zm-button size="small" type="primary" @click="generateJwtToken()" :loading="loading">Generate</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { createApplication, listNamespace, listApplication, deleteApp, generateJwtToken, initCmk, getAppById, generateBackup } from '@/api/index'
import { getPermission } from '@/api/permission'
import Cmk from './cmk'
export default {
    name: 'application',
    components: {
        Cmk
    },
    data () {
        var validateApplicationName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter application name'))
            } else {
                var reg = /^[0-9a-z.\-_]+$/
                console.log(reg.test(value))
                if (reg.test(value) && value.length <= 32) {
                    callback()
                }
                callback(new Error('invalid application name!'))
            }
        }
        return {
            permission: {
                isSuperAdmin: false,
                isSuperOperator: false,
                manageableResources: []
            },
            selectedCmkAppId: '',
            selectedCmkAppName: '',
            applicationName: '',
            list: [],
            namespaceList: [],
            loading: false,
            namespace: '',
            registerVisible: false,
            isCreate: true,
            ownerList: [],
            inputTagVisible: false,
            inputTagValue: '',
            register: {
                id: null,
                namespace: '',
                name: '',
                description: '',
                owner: '',
                cmkInit: false
            },
            pickerOptions: {
                disabledDate: function (time) {
                    if ((time.getTime() - Date.now()) <= 3600 * 24 * 1000 * 30 && (time.getTime() - Date.now()) >= 0) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            generateVisible: false,
            generateForm: {
                applicationId: '',
                expiredTime: ''
            },
            token: '',
            pageable: {
                pageSize: 10,
                pageNumber: 1
            },
            registerRules: {
                name: [
                    { required: true, validator: validateApplicationName, trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        localStorage.path = this.$route.path
        localStorage.params = ''
        if (this.$route.query.params) {
            this.applicationName = JSON.parse(this.$route.query.params).applicationName
            this.selectedCmkAppId = JSON.parse(this.$route.query.params).selectedCmkAppId
            this.selectedCmkAppName = JSON.parse(this.$route.query.params).selectedCmkAppName
            this.pageable = JSON.parse(this.$route.query.params).pageable
        }
        this.fetchPermission()
        this.namespace = localStorage.namespace
        this.fetchNamespace()
        this.fetchData()
    },
    watch: {
        'applicationName' () {
            this.setURL()
        },
        'selectedCmkAppId' () {
            this.setURL()
        },
        'selectedCmkAppName' () {
            this.setURL()
        },
        'pageable.pageSize' () {
            this.setURL()
        },
        'pageable.pageNumber' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { applicationName, selectedCmkAppId, selectedCmkAppName, pageable } = this
            const data = {
                applicationName,
                selectedCmkAppId,
                selectedCmkAppName,
                pageable
            }
            var url = `${location.href.split('?params=')[0]}?params=${JSON.stringify(data)}`
            history.pushState({ url: url }, '', url)
            // localStorage.route = url
            localStorage.params = JSON.stringify(data)
        },
        buttonPermission (appId) {
            return this.permission.manageableResources.indexOf(appId) > -1 || this.permission.manageableResources.indexOf('*') > -1
        },
        fetchPermission () {
            getPermission('application').then(response => {
                this.permission.isSuperAdmin = response.data.isSuperAdmin
                this.permission.isSuperOperator = response.data.isSuperOperator
                response.data.manageableResources.map(item => {
                    const data = item.split('/')
                    const appData = data[0].split(':')[1].split('|')
                    appData.map(app => {
                        this.permission.manageableResources.push(app)
                    })
                })
            })
        },
        handleCopy () {
            var btn = document.getElementById('copy-btn')
            btn.click()
        },
        fetchNamespace () {
            if (localStorage.namespaceList) {
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                listNamespace().then(response => {
                    this.namespaceList = response
                })
            }
        },
        setNamespace (val) {
            localStorage.namespace = val
            this.resetSetItem('namespace', this.value)
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        fetchData () {
            this.namespace = localStorage.namespace
            if (this.namespace) {
                this.loading = true
                listApplication(this.namespace, this.applicationName, 'application').then(response => {
                    this.list = response.data
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        showRegister () {
            if (localStorage.namespace) {
                this.register.id = null
                this.register.namespace = localStorage.namespace
                this.register.name = ''
                this.register.description = ''
                this.register.owner = ''
                this.register.cmkInit = false
                this.ownerList = []
                this.registerVisible = true
                this.isCreate = true
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please select a namespace before register application!'
                })
            }
        },
        showEdit (id) {
            getAppById(id).then(response => {
                this.register.id = id
                this.register.namespace = response.namespace
                this.register.name = response.name
                this.register.description = response.description
                this.register.owner = response.owner
                this.register.cmkInit = response.cmkInit
                this.ownerList = response.owner ? response.owner.split(',') : []
                this.registerVisible = true
                this.isCreate = false
            })
        },
        createApplication () {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.register.owner = ''
                    this.ownerList.map(item => {
                        if (item) {
                            this.register.owner += item + ','
                        }
                    })
                    this.register.owner = this.register.owner.substr(0, this.register.owner.length - 1)
                    createApplication(this.register).then(response => {
                        this.fetchData()
                        this.registerVisible = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        showGenerateToken (id) {
            this.token = ''
            this.generateForm.applicationId = id
            this.generateForm.expiredTime = (new Date()).getTime() + 86400000 * 3
            this.generateVisible = true
            this.generateJwtToken()
        },
        generateJwtToken () {
            this.loading = true
            generateJwtToken(this.generateForm).then(response => {
                // this.$message({
                //     type: 'success',
                //     message: response.token,
                //     duration: 0,
                //     showClose: true
                // })
                this.$message.success('Generate success')
                this.token = response.token
                this.loading = false
                // this.generateVisible = false
            }).catch(() => {
                this.loading = false
            })
        },
        listCmk (row) {
            this.selectedCmkAppId = row.id
            this.selectedCmkAppName = row.applicationName
        },
        initCmk (id) {
            this.$confirm('This will init cmk of the application. Continue?', 'Warning', {
                confirmButtonText: 'Init',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                initCmk(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Init success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Init canceled'
                })
            })
        },
        generateBackup (id) {
            this.$confirm('This will generate a backup for the application. Continue?', 'Warning', {
                confirmButtonText: 'Generate',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                generateBackup(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Generate success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Generate canceled'
                })
            })
        },
        deleteApp (id) {
            this.$confirm('This will delete the application. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteApp(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        copySuccess (e) {
            this.$message.success('Copy success')
        },
        handleClose (tag) {
            this.ownerList.splice(this.ownerList.indexOf(tag), 1)
        },
        showInput () {
            this.inputTagVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm () {
            var inputTagValue = this.inputTagValue
            if (inputTagValue) {
                if (this.ownerList.indexOf(inputTagValue) === -1) {
                    this.ownerList.push(inputTagValue)
                } else {
                    this.$message({
                        type: 'warning',
                        message: 'Duplicated value'
                    })
                }
            }
            this.inputTagVisible = false
            this.inputTagValue = ''
        }
    }
}
</script>
<style>
@import '../assets/icons/iconfont.css';
.zm-message.is-closable .zm-message__content {
    word-break: break-all;
    line-height: 1.5;
    padding-right: 25px;
}
.input-tag {
    margin: 4px 10px 4px 0;
    padding: 0 20px 0 10px;
    height: 32px;
    line-height: 28px;
}
.input-tag.zm-tag .zm-tag__close {
    top: 7px;
}
.input-new-tag.zm-input {
    width: 200px;
    vertical-align: baseline;
}
</style>
